import React, {useEffect} from 'react';
import Map from '../components/Map/Map';
import OutroWrong from '../components/OutroWrong/OutroWrong';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';

const FeedbackCorrect = ({ inactivity }) => {

    // define variables
    const { locale, location } = useParams();
    
    // change language
    const { i18n } = useTranslation();

    // trigger tracking
    useEffect(() => {

        // set language
        i18n.changeLanguage(locale);
        
        // perform tracking
        // gtag('event', 'screen_view', {
        //     'screen_name': `wrong_${locale}`
        // });

        gtag('event', 'page_view', {
            page_path: `/${locale}/wrong`
        });

        // set inactivity functionality
        inactivity();

    }, []);

    // render html
    return(
        <>
            <OutroWrong language={locale} location={location} />
            <Map type="blur" />
        </>
    );
}

export default FeedbackCorrect;